import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Main from "./components/Main";
import Archive from "./components/Archive";
import DocumentsList from "./components/DocumentsList";
import DocumentViewer from "./components/DocumentViewer";
import ArchiveMap from "./components/ArchiveMap";
import './App.css';
import {AuthProvider} from "./context/AuthContext";
import {ShowProvider} from "./context/ShowContext";
import {PageProvider} from "./context/PageContext";
import {DocumentProvider} from "./context/DocumentContext";
import {ArchiveProvider} from "./context/ArchiveContext";
import {ThemeProvider} from "./context/ThemeContext";
import {LanguageProvider} from "./context/LanguageContext";
import {IntroductionProvider} from "./context/IntroductionContext";
import Hero from "./components/Hero";

function App() {
  return (
    <Router>
      <div className="App">
        <LanguageProvider>
          <ThemeProvider>
            <ShowProvider>
              <AuthProvider>
                <ArchiveProvider>
                  <DocumentProvider>
                    <PageProvider>
                      <IntroductionProvider>
                        <Header/>
                        <Routes>
                          <Route path="/" element={
                            <>
                              <Hero/>
                              <Main/>
                            </>
                          } />
                          <Route path="/archive" element={<Archive />} />
                          <Route path="/archive/:authorId" element={<DocumentsList />} />
                          <Route path="/document/:documentId" element={<DocumentViewer />} />
                          <Route path="/archive-map" element={<ArchiveMap />} />
                        </Routes>
                      </IntroductionProvider>
                    </PageProvider>
                  </DocumentProvider>
                </ArchiveProvider>
              </AuthProvider>
            </ShowProvider>
          </ThemeProvider>
        </LanguageProvider>
      </div>
    </Router>
  );
}

export default App;

